/* eslint-disable eqeqeq */
/* eslint-disable no-redeclare */
/* eslint-disable no-var */
/* eslint-disable block-scoped-var */
import Cookies from 'js-cookie';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import userService from '../../../../general/js/user/user-service';
import {
    TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME
} from '../../../../general/js/user/constants';
import { safeParseJSON } from '../../../../general/js/general-helpers';
import { CookieNames } from '../../../../general/js/utils/cookies';
import { MembershipTypes } from '../../../../general/js/utils';

export const getComponentVisibility = (componentVisibility) => {
    const isMastercardUser = handleCheckIsMasterCardMember(CookieNames.TOCH_USER_MEMBERSHIPS);

    if (componentVisibility === 'mastercard' && !isMastercardUser) return false;

    if (componentVisibility === 'non-mastercard' && isMastercardUser) return true;

    return true;
};

export const getTOCHMembershipArray = (userAccountData) => {
    if (!isEmpty(userAccountData)) return userAccountData.split(';');

    return null;
};

export const handleCheckMembershipExists = (membershipArray, membership) => {
    if (membershipArray !== null) return membershipArray.includes(membership);

    return null;
};

export const handleCheckIsMasterCardMember = (localStorageKey) => {
    const jsonUserMemberships = userService.getDataFromLocalStorage(localStorageKey);
    const userMembershipsArray = getTOCHMembershipArray(safeParseJSON(jsonUserMemberships));
    const isMasterCardUser = handleCheckMembershipExists(userMembershipsArray, MembershipTypes.OneClubAdvantage);

    return isMasterCardUser;
};

export const getMasterCardRegisterObject = (masterCardData) => {
    const options = {
        backgroundImage: masterCardData.item.backgroundImage,
        masterCardLogo: masterCardData.item.masterCardBranding.mastercardLogo,
        masterCardText: masterCardData.item.masterCardBranding.mastercardText,
        masterCardNumberLabel: masterCardData.item.masterCardNumberLabel,
        nameLabel: masterCardData.item.nameLabel,
        title: masterCardData.item.title,
        bottomInfo: masterCardData.item.bottomInfo,
        postcodeLabel: masterCardData.item.postcodeLabel,
        ctaSignUpForMastercardLink: masterCardData.item.ctaSignUpForMasterCard,
        notMasterCardNumberErrorMessage: masterCardData.item.notMasterCardNumberErrorMessage,
        masterCardRegistrationSuccessTitle: masterCardData.item.masterCardRegistrationSuccess.title,
        masterCardRegistrationSuccessLabel: masterCardData.item.masterCardRegistrationSuccess.label,
        masterCardRegistrationSuccessDescription: masterCardData.item.masterCardRegistrationSuccess.description,
        masterCardRegistrationSuccessCTALink: masterCardData.item.masterCardRegistrationSuccess.ctaLink,
        callbackUrl: masterCardData.item.masterCardRegistrationSettings.callbackUrl,
        regexToVerifyMastercard: masterCardData.item.masterCardRegistrationSettings.cardVerificationRegex,
        soundToBePlayedAfterSuccessRegister: masterCardData.item.masterCardRegistrationSettings.soundToBePlayedAfterSuccessRegister.url
    };

    return options;
};

export const handleMastercardRegistrationEnforce = (props) => {
    const {
        componentVisibility,
        enableMastercardRegistrationEnforce
    } = props;

    const enableEnforce = enableMastercardRegistrationEnforce.toLowerCase() === 'true';
    const componentVisibilityForUser = getComponentVisibility(componentVisibility);
    if (!componentVisibilityForUser && enableEnforce) {
        return true;
    }

    return false;
};

export const calculateRemainingDate = (countdownTimer) => {
    const countdownTimerDate = new Date(countdownTimer);

    const d = new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const ukTimeNowAsDate = isBSTinEffect(d) ? new Date(utc + (3600000 * 1)) : new Date(utc);

    if (countdownTimerDate < ukTimeNowAsDate) {
        const newObject = {
            minutes: 0,
            hours: 0,
            days: 0
        };

        return newObject;
    }

    let delta = Math.abs(countdownTimerDate - ukTimeNowAsDate) / 1000;

    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    const newDate = {
        minutes,
        days,
        hours
    };

    return newDate;
};

export const checkIfExpired = (countdownTimer) => {
    const countdownTimerDate = new Date(countdownTimer);

    const d = new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const ukTimeNowAsDate = isBSTinEffect(d) ? new Date(utc + (3600000 * 1)) : new Date(utc);

    if (countdownTimerDate < ukTimeNowAsDate) return true;

    return false;
};

export const isBSTinEffect = (d) => {
    let lSoM = null;
    let lSoO = null;

    // Loop over the 31 days of March for the current year
    for (var i = 31; i > 0; i--) {
        var tmp = new Date(d.getFullYear(), 2, i);
        // If it's Sunday
        if (tmp.getDay() == 0) {
            // last Sunday of March
            lSoM = tmp;
            break;
        }
    }

    // Loop over the 31 days of October for the current year
    for (var i = 31; i > 0; i--) {
        var tmp = new Date(d.getFullYear(), 9, i);
        // If it's Sunday
        if (tmp.getDay() == 0) {
            // last Sunday of October
            lSoO = tmp;
            break;
        }
    }

    // 0 = DST off (GMT)
    // 1 = DST on  (BST)
    if (d < lSoM || d > lSoO) {
        return 0;
    }

    return 1;
};

export const getVerificationEndpoint = (data) => {
    const { verificationEndpoint } = data;

    const email = userService.getDataFromLocalStorage(CookieNames.TOCH_USER_EMAIL);
    const updatedEndpoint = verificationEndpoint + email;

    return updatedEndpoint;
};

export const getUserAddressBooks = () => {
    const userAddressBooks = userService.getDataFromLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME);

    if (userAddressBooks === null || userAddressBooks === undefined || userAddressBooks === '') return null;

    return userAddressBooks;
};

export const verifyUserInAddressBook = (addressBookList, addressBookID) => {
    if (addressBookList === null) return false;

    const addressBooksList = JSON.parse(addressBookList);
    const addressBookIdAsInt = parseInt(addressBookID, 10);
    const isInAddressBook = addressBooksList.some((element) => element.AddressBookId === addressBookIdAsInt);

    return isInAddressBook;
};

export const handlePersonalizedCompetitionList = (userAddressBooks, competitions) => {
    if (userAddressBooks === null) return null;

    for (let i = 0; i < competitions.length; i++) {
        const completedCompetitionIndex = userAddressBooks.findIndex((item) => item.AddressBookId === competitions[i].dotmailerDetails.addressBookID);

        if (completedCompetitionIndex !== -1) {
            competitions.splice(i, 1);
            i--;
        }
    }

    return competitions;
};

export const addCompletedFormToAddressBookLocalStorage = (dotmailerId, dotmailerName) => {
    const userAddressBooks = getUserAddressBooks();
    const userAddressBooksObject = JSON.parse(userAddressBooks);
    const dotmailerObject = {
        AddressBookId: parseInt(dotmailerId, 10),
        AddressBookName: dotmailerName
    };

    if (userAddressBooksObject === null) return [dotmailerObject];

    userAddressBooksObject.push(dotmailerObject);

    return userAddressBooksObject;
};

export const getUserDetailsFromCookie = () => {
    const cookie = Cookies.get(CookieNames.TOCH_USER_DATA);

    return safeParseJSON(cookie);
};
